<script setup>
import "@/assets/main.css";

</script>
<template>
    <div class="flex h-fit justify-center py-3 ">
        <div class="main-content flex flex-col justify-center text-center">
            <div class=" mb-3">
                <div class="m-auto px-12 py-8 border border-gold-dark/70 rounded-t-full backdrop-blur-sm">
                    <img src="../../../public/photos/anakdika/img4.webp" width="250px" class="rounded-t-full " />

                    <h3 class="text-gold-dark font-parisienne text-2xl mt-8">
                        Anak Andika & Istri
                    </h3>
                    <div class="mt-3 text-sm text-alt-dark ">
                        <p>Anak pertama dari pasangan</p>
                        <strong>
                            Bapak Putu Andika Putra
                            <br />
                            & Ibu Istri Andika
                        </strong>
                    </div>
                    <p class="mt-2 text-sm text-alt-dark ">Jl. Srikandi Gang Mangga, Sambangan</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
